import useCountUp from "../hooks/useCountUp";
import { STATS } from "../data/content";

function StatItem({ value, suffix, label }) {
  const { ref, value: current } = useCountUp(value, 2200);
  return (
    <div className="flex flex-col items-center px-4 py-10 text-center md:py-16">
      <div ref={ref} className="font-playfair text-6xl font-bold leading-none text-white sm:text-7xl lg:text-8xl">
        {current}
        <span className="text-gold">{suffix}</span>
      </div>
      <p className="mt-4 text-[0.7rem] uppercase tracking-[0.28em] text-neutral-400">{label}</p>
    </div>
  );
}

export default function Stats() {
  return (
    <section data-testid="stats-section" className="relative w-full bg-[#050505]">
      <div className="pad-x">
        <div className="grid grid-cols-2 lg:grid-cols-4">
          {STATS.map((s) => (
            <StatItem key={s.label} {...s} />
          ))}
        </div>
      </div>
    </section>
  );
}
